import React from "react";
import Layout from "./layout/Layout";
import { useTranslation } from "react-i18next";
import Logo from "../assets/dmn_logo.png";
import { assetUrl } from "../utils/assetUrl";
import { translatePreorderRefusal } from "../utils/preorderRefusalMessage";
import "./PreOrderUnavailablePage.css";

interface PreOrderUnavailablePageProps {
  /** Reason returned by Collins when pre-orders are refused (e.g. closed). */
  message?: string;
}

const PreOrderUnavailablePage: React.FC<PreOrderUnavailablePageProps> = ({ message }) => {
  const { t } = useTranslation();
  const refusalMessage = translatePreorderRefusal(t, message);
  return (
    <Layout
      main={
        <div className="info-page-container">
          <img src={assetUrl(Logo)} alt="DesignMyNight Logo" className="logo" />
          <div className="info-message-box">
            <span className="info-icon" aria-hidden="true">
              ℹ️
            </span>
            <div>
              <h1 className="gc-heading">{t("preorder_unavailable_title", "Pre-order Unavailable")}</h1>

              <p className="description info-message">
                {refusalMessage ??
                  t(
                    "preorder_unavailable_message",
                    "We're sorry, but pre-ordering is not currently available for this booking. This may be because the booking has expired, been cancelled, or pre-orders are not enabled for this venue.",
                  )}
              </p>
              <p className="description info-message">
                {t(
                  "preorder_unavailable_contact",
                  "If you believe this is an error, please contact the venue directly for assistance.",
                )}
              </p>
            </div>
          </div>
        </div>
      }
      aside={undefined}
    />
  );
};

export default PreOrderUnavailablePage;
